import Reveal from './ui/Reveal';
import Icon from './ui/Icon';
import SectionHeading from './ui/SectionHeading';
import { services } from '../data/content';

const Services = () => (
  <section id="services" className="section" aria-labelledby="services-title">
    <div className="container-page">
      <SectionHeading
        id="services-title"
        eyebrow="Services"
        title="Everything your business needs to work well online"
        lead="From a first website to custom software and AI features, I handle design, development and launch, so you deal with one person from idea to release."
      />

      <ul className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
        {services.map((service, i) => (
          <Reveal as="li" key={service.title} delay={(i % 3) * 70} className="flex">
            <article className="card card-hover group flex w-full flex-col p-6 sm:p-7">
              <span className="grid h-11 w-11 place-items-center rounded-xl border border-indigo-300/20 bg-indigo-400/10 text-indigo-300 transition-colors group-hover:bg-indigo-400/15">
                <Icon name={service.icon} className="h-5 w-5" />
              </span>
              <h3 className="mt-5 text-lg font-semibold tracking-tight text-fg">{service.title}</h3>
              <p className="mb-5 mt-2.5 text-[15px] leading-relaxed text-muted">{service.description}</p>
              <p className="mt-auto flex items-start gap-2.5 border-t border-white/[0.07] pt-5 text-sm font-medium text-fg">
                <Icon name="Check" className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" strokeWidth={2.5} />
                {service.benefit}
              </p>
            </article>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);

export default Services;
